/**
 * Zaoud wave reveal on scroll (mega-menu style stagger).
 * Plays once per section on first enter — does not replay on scroll back.
 * Theme settings → Animations → "Zaoud wave reveal on scroll".
 * Skips .zaoud-reveal-skip / hero banner.
 */
(function () {
  if (!document.body) return;
  if (document.body.getAttribute('data-zaoud-wave-reveal') === 'false') return;

  var REDUCE =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DESIGN = document.documentElement.classList.contains('shopify-design-mode');
  var watched = [];

  var ITEM_SELECTORS = [
    '.zaoud-featured-collection__toolbar',
    '.zaoud-featured-collection__description',
    '.zaoud-featured-collection .grid__item',
    '.zaoud-stl__toolbar',
    '.zaoud-stl__stage',
    '.zaoud-stl__aside',
    '.zaoud-blog__toolbar',
    '.zaoud-blog__item',
    '.zaoud-why-buy__header',
    '.zaoud-why-buy__item',
    '.zaoud-image-pair__item',
    '.zaoud-image-trio__item',
    '.zaoud-brand-logos__toolbar',
    '.zaoud-brand-logos__viewport',
    '.zaoud-perfume-by-scent__toolbar',
    '.zaoud-perfume-by-scent__viewport',
    '.zaoud-brand-spotlight__stage',
    '.zaoud-promo-split__grid',
    '.zaoud-image-banner__frame',
    '.zaoud-video-product__toolbar',
    '.zaoud-video-product__layout > *',
    '.zaoud-page-hero__content > *',
    '.zaoud-about__story > *',
    '.zaoud-contact__grid > *',
    '.zaoud-collection-banner__content > *',
    '.zaoud-brand-grid__toolbar',
    '.zaoud-brand-grid__item',
    '.zaoud-progress-slider__toolbar',
    '.zaoud-progress-slider__stage',
    '.zaoud-product-details__header',
    '.zaoud-product-details__panel',
    '.zaoud-product-ingredients__title',
    '.zaoud-ingredients-notes__group',
    /* Newsletter */
    '.zaoud-newsletter__copy',
    '.zaoud-newsletter__form-wrap',
    /* FAQ */
    '.zaoud-faq__header',
    '.zaoud-faq__category',
    '.zaoud-faq__item',
    '.zaoud-faq__cta',
    /* Footer */
    '.footer__brand',
    '.footer__social',
    '.footer__menu',
    '.footer-contact-panel',
    '.footer__content-bottom .footer__column',
    '.footer__copyright'
  ];

  function isSkipped(section) {
    return (
      section.classList.contains('zaoud-reveal-skip') ||
      section.classList.contains('section-zaoud-hero-banner') ||
      Boolean(section.querySelector('[data-zaoud-hero-banner], .zaoud-hero-banner')) ||
      Boolean(section.querySelector('product-info, .zaoud-pdp-gallery'))
    );
  }

  function isEntering(el) {
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < vh * 0.92 && rect.bottom > vh * 0.06;
  }

  function collectItems(section) {
    var found = [];
    var seen = typeof Set !== 'undefined' ? new Set() : null;

    ITEM_SELECTORS.forEach(function (selector) {
      var nodes = section.querySelectorAll(selector);
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (seen) {
          if (seen.has(el)) continue;
          seen.add(el);
        }
        found.push(el);
      }
    });

    if (found.length) return found;

    var root =
      section.querySelector('[class*="zaoud-"]') ||
      section.querySelector('.page-width') ||
      section.firstElementChild;
    if (!root || !root.children) return [section];

    var kids = [];
    for (var c = 0; c < root.children.length; c++) {
      var child = root.children[c];
      if (child.matches && child.matches('script, style, noscript, link')) continue;
      kids.push(child);
    }
    return kids.length ? kids : [root];
  }

  function reveal(section) {
    if (!section || section.classList.contains('is-inview')) return;
    section.classList.add('is-inview');
    var idx = watched.indexOf(section);
    if (idx > -1) watched.splice(idx, 1);
  }

  function flush() {
    if (!watched.length) return;
    /* Iterate a copy — reveal() removes from watched */
    var pending = watched.slice();
    for (var i = 0; i < pending.length; i++) {
      if (isEntering(pending[i])) reveal(pending[i]);
    }
  }

  function prepareSection(section) {
    if (!section || section.getAttribute('data-zaoud-reveal-init') === 'true') return;
    section.setAttribute('data-zaoud-reveal-init', 'true');

    if (isSkipped(section)) return;

    section.classList.remove('zaoud-cv-auto');

    var items = collectItems(section);
    section.classList.add('zaoud-reveal-section');

    for (var i = 0; i < items.length; i++) {
      items[i].classList.add('zaoud-reveal-item');
      items[i].style.setProperty('--zaoud-reveal-i', String(Math.min(i, 18)));
    }

    if (DESIGN || REDUCE) {
      section.classList.add('is-inview', 'zaoud-reveal--cancel');
      return;
    }

    if (section.classList.contains('is-inview')) return;

    watched.push(section);

    if (isEntering(section)) {
      setTimeout(function () {
        reveal(section);
      }, 40);
    }
  }

  function boot() {
    var main = document.getElementById('MainContent');
    if (main) {
      var sections = main.querySelectorAll('.shopify-section');
      for (var i = 0; i < sections.length; i++) {
        prepareSection(sections[i]);
      }
    }

    /* Footer group renders outside #MainContent */
    var footers = document.querySelectorAll('.shopify-section .footer');
    for (var f = 0; f < footers.length; f++) {
      var footerSection = footers[f].closest('.shopify-section');
      if (footerSection) prepareSection(footerSection);
    }

    flush();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('scroll', flush, { passive: true });
  window.addEventListener('resize', flush, { passive: true });
  document.addEventListener('visibilitychange', flush);
  document.addEventListener('scroll', flush, { passive: true, capture: true });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    if (!section.classList.contains('shopify-section')) {
      section = section.closest ? section.closest('.shopify-section') : null;
    }
    if (!section) return;
    section.removeAttribute('data-zaoud-reveal-init');
    section.classList.remove('is-inview', 'zaoud-reveal-section', 'zaoud-reveal--cancel');
    var idx = watched.indexOf(section);
    if (idx > -1) watched.splice(idx, 1);
    prepareSection(section);
    flush();
  });
})();
